import React, { useState, useEffect, useRef } from 'react';
import { Badge, Button, Col, Form, InputGroup, Row, Table, Modal, ModalTitle } from 'react-bootstrap';
import { Link } from 'react-router-dom';

import { MultiSelect } from 'react-multi-select-component';
import Dropdown from 'react-bootstrap/Dropdown';
import Trash from '../../../assets/images/trash.png';
import Autosuggest from 'react-autosuggest';
import Slider from "react-slick";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faXmark, faEllipsis, faTrashCan, faPencil, faEnvelope, faArrowLeft, faChevronDown, faChevronUp, faCircleXmark, faPlus, faCircleCheck } from '@fortawesome/free-solid-svg-icons';
import { toast } from 'react-toastify';
import Select from 'react-select';
import { withoutRFSToken, withRFSToken } from '../../../Services/axios.js';
import { STATIONGRID, TRUCKERADDEMAIL, TRUCKEREDITEMAIL, TRUCKERDELEMAIL, TRUCKERSAVERATE, TRUCKERRATELIST, GETDESTINATION } from '../../../Utils/conts.js';
import ImageUpload from '../../../Components/common/ImageUpload.js';
import ManageRate from './ManageRate.js';
import TruckSchedule from './TruckSchedule.js';

// const getLocalEmail = () => {
//     const lists = localStorage.getItem("truckerEmail"); 

//     if (lists) {
//       return JSON.parse(lists);
//     } else {
//       return [];
//     }
//   };

const TruckerDetails = ({ rowData, stationID, reload, onEdit, dload }) => {

    const [boardPoint, setBoardpoint] = useState([]);
    const isMounted = useRef(false);
    const truckerParent = rowData.args.row.bounddata;
    console.log("🚀 ~ TruckerDetails ~ truckerParent:", truckerParent)
    const [disLoading, setDisLoading] = useState(false);
    const [show, setShow] = useState(false);
    const modalShow = () => setShow(true)
    const modalClose = () => { setShow(false); setValueOffpoint(''); setValue(''); };

    const [tempShow, setTempShow] = useState(true);
    const TempYes = () => setTempShow(true);
    const TempNo = () => setTempShow(false);

    // const getLocalData = () => {
    //     const storedData = localStorage.getItem("truckerData");
    //     return storedData ? JSON.parse(storedData) : [];

    // }
    // useEffect(() => {
    // setAddress(getLocalData());
    // setItems(getLocalEmail());
    // }, []);

    const currencies = [
        { 'EUR': '€' },
        { 'USD': '$' },
        { 'PHP': '₱' },
        { 'JPY': '¥' },
        { 'GBP': '£' },
        { 'AUD': 'A$' },
        { 'CHF': 'Fr.' },
        { 'CAD': 'C$' },
        { 'MXN': '$' },
        { 'CNY': '¥' },
        { 'NZD': 'NZ$' },
        { 'SEK': 'kr' },
        { 'RUB': '₽' },
        { 'HKD': 'HK$' },
        { 'NOK': 'kr' },
        { 'SGD': 'S$' },
        { 'TRY': '₺' },
        { 'KRW': '₩' },
        { 'ZAR': 'R' },
        { 'BRL': 'R$' },
        { 'INR': '₹' },
        { 'SAR': '﷼' },
        { 'DKK': 'kr' },
        { 'RON': 'lei' },
        { 'XAF': 'Fr' },
        { 'XOF': 'Fr' },
        { 'DOP': 'RD$' },
        { 'HTG': 'G' },
        { 'BBD': 'Bds$' },
        { 'TTD': 'TT$' },
        { 'XCD': 'EC$' },
        { 'ANG': 'ƒ' },
        { 'COP': 'COL$' },
        { 'XDR': 'SDR' },
        { 'XBT': '₿' },
    ];



    const [inputAddress, setInputAddress] = useState({
        HandlerName: '', Address1: '', Address2: '', PostalCode: '', Phone: '', Email: ''
    });
    const [address, setAddress] = useState([]);

    const [value, setValue] = useState('');
    const [suggestionsBp, setSuggestionsBp] = useState([]);
    const [suggestionsOffpoint, setSuggestionsOffpoint] = useState([]);
    const [fetchStation, setFetchStation] = useState([]);
    const [ratechart, setRateChart] = useState([]);
    const [formData, setFormData] = useState({
        // type_of_truck: 'B',
        // bookingTruck_type: 'E',
        // new_schedule_data: {
        //     trip_type: 'O',
        // },
        // coload: [],
        // adr: '1',
        // extra_truck_specification: [],
        // carriers: [],
        // filesWithBase64: [],
        // temperature_range_one_start: '0',
        // temperature_range_one_end: '0',
        // temperature_range_two_start: '0',
        // temperature_range_two_end: '0',
        // temperature_range_three_start: '0',
        // temperature_range_three_end: '0',
        // rateType: 'FM',
        viaStation: ['',],
    })
    const [selectedRowData, setSelectedRowData] = useState(null);

    const fetchData = async () => {
        try {
            const res = await withRFSToken.post(STATIONGRID, {})
                .then(function (res) {
                    const innerData = res.data.response_data;
                    const activeInnerData = res.data.response_data.Active;
                    const transformedData = activeInnerData ? activeInnerData.map(item => ({
                        id: item.id,
                        value: item.station_id,
                        label: item.station_code
                    })) : []; // For multiselect
                    const transformData = innerData.Active ? innerData.Active.map((data) => ({
                        ...data,
                        value: data.id,
                        label: data.station_code,
                    })) : [];
                    setBoardpoint(transformData);
                    setstations(transformedData); // For multiselect
                    setFetchStation(innerData.Active);
                    setSuggestionsBp(innerData.Active);
                    setSuggestionsOffpoint(innerData.Active);
                    return activeInnerData
                });

        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };
    const fetchDestination = async () => {
        try {
            const res = await withRFSToken.post(GETDESTINATION, {})
                .then(function (res) {
                    const innerData = res.data.response_data;
                    const activeInnerData = res.data.response_data.Active;

                    const transformData = innerData ? innerData.map((data) => ({
                        ...data,
                        value: data.station_id,
                        label: data.port_code,
                    })) : [];
                    setBoardpoint(transformData);
                    setstations(transformData); // For multiselect
                    setFetchStation(innerData);
                    setSuggestionsBp(innerData);
                    setSuggestionsOffpoint(innerData);
                    return activeInnerData
                });

        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };

    const loadDetails = async (uldNumber) => {
        setDisLoading(true);
        try {
            const res = await withRFSToken.post('trucker-details', { trucker_id: uldNumber })
                .then(function (res) {
                    const innerData = res.data.response_data;
                    setSelectedRowData(innerData);
                    setDisLoading(false);
                });
        } catch (error) {
            console.error('Error fetching data:', error);
            setDisLoading(false);
        }
    }

    const onChange = (event, { newValue }) => {
        console.log('567', newValue);
        setValue(newValue);
        const stnId = fetchStation.filter((stn) => stn.station_code == newValue);
        if (stnId.length > 0) {
            const bpId = stnId[0]
            setFormData({
                ...formData,
                boardPoint: bpId.id
            });
        }

    };
    const inputProps = {
        placeholder: 'Type a Stations',
        value,
        onChange: onChange,
    };

    // console.log('688', stationData)
    // data from station component
    const onSuggestionsFetchRequested = ({ value }) => {
        const inputValue = value.trim().toLowerCase();
        const inputLength = inputValue.length;

        setSuggestionsBp(
            inputLength === 0
                ? []
                : fetchStation.filter(
                    (fruit) => fruit.station_code.toLowerCase().slice(0, inputLength) === inputValue
                    //&& fruit.station_code !== (selectedOffpoint && selectedOffpoint.station_code)
                )
        );

        // setShowAddButton(inputLength > 0 && suggestionsBp.length === 0); commented 30.04.24
    };

    const onSuggestionsClearRequested = () => {
        setSuggestionsBp([]);
        // setSelectedOffpoint(null); // TO CLEAN FIRST FIELD

        // setShowAddButton(false);
    };

    const getSuggestionValue = (suggestion) => suggestion.station_code;

    const renderSuggestion = (suggestion) => <div>{suggestion.station_code}</div>;

    const [valueOffpoint, setValueOffpoint] = useState('');
    const [selectedOffpoint, setSelectedOffpoint] = useState(null);
    const onChangeOffpoint = (event, { newValue }) => {
        setValueOffpoint(newValue);
        const stnId = fetchStation.filter((stn) => stn.station_code == newValue);
        if (stnId.length > 0) {
            const bpId = stnId[0]
            setFormData({
                ...formData,
                offPoint: bpId.id
            });
        }

    };
    const onSuggestionsFetchRequestedOffpoint = ({ value }) => {
        const inputValue = value.trim().toLowerCase();
        const inputLength = inputValue.length;

        setSuggestionsOffpoint(
            inputLength === 0
                ? []
                : fetchStation.filter(
                    (fruit) => fruit.station_code.toLowerCase().slice(0, inputLength) === inputValue
                    //&& fruit.station_code !== (bpaddress && bpaddress.station_code)
                )
                    .filter(suggestion => suggestion.station_code !== (selectedOffpoint && selectedOffpoint.station_code))
        );
        // setShowAddButtonOffpoint(inputLength > 0 && suggestionsBp.length === 0);
    };

    const onSuggestionsClearRequestedOffpoint = () => {
        setSuggestionsOffpoint([]);
        // setBpaddress(null);
        // setShowAddButtonOffpoint(false);
    };

    const getSuggestionValueOffpoint = (suggestion) => suggestion.station_code;

    const renderSuggestionOffpoint = (suggestion) => <div>{suggestion.station_code}</div>;

    const onSelectOffpoint = (offpoint) => {
        // const addressOptions = offpoint.station_addresses.map(address => (
        //     `${address.handler_name} - ${address.address_1}`
        // ));
        // setSelectedOffpoint(addressOptions);
        // if (offpoint) { setSelectedOffpoint(offpoint.station_addresses); }

        setFormData({
            ...formData,
            offPoint: offpoint.id
        });
    };

    useEffect(() => {
        if (isMounted.current) return;
        reloadRates();
        // fetchData();
        fetchDestination();
        loadDetails(truckerParent.trucker_id);

        isMounted.current = true;
    }, []);

    // useEffect(() => {
    //     loadDetails(truckerParent.trucker_id);
    // }, [reload]);

    const handleFormOnchange = (e) => {
        const { name, value } = e.target;
        setFormData(prevFormData => ({
            ...prevFormData,
            [name]: value
        }));
    }
    const addRates = async () => {
        console.log('addrates', formData);
        try {
            const res = await withRFSToken.post(TRUCKERSAVERATE, formData);
            // .then(function (res) {
            // const innerData = res;
            if (res.data.response_code == 200) {
                reloadRates();
                setValueOffpoint('');
                setValue('');
                modalClose();
            }
            // });

        } catch (error) {
            console.error('Error sending request:', error);
        }

    }
    const reloadRates = async () => {
        try {
            const res = await withRFSToken.get(`fixed-rate-list?trucker_id=${truckerParent.trucker_id}`)
                .then(function (res) {
                    const innerData = res.data.response_data;
                    setRateChart(innerData);
                });
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    }
    const handleChange = (e) => {
        setInputAddress({ ...inputAddress, [e.target.name]: e.target.value });
    };


    // Email Add Section Start
    // const getLocalEmail = () => {
    //     const lists = localStorage.getItem("truckerEmail");
    //     return lists ? JSON.parse(lists) : [];
    // }
    const emailArray = JSON.parse(truckerParent.trucker_request_emails);
    const [emailShow, setEmailShow] = useState(false);
    const inputEmailShow = () => setEmailShow(true);
    const [inputData, setInputData] = useState("");
    const [items, setItems] = useState(emailArray);
    const [editEmail, setEditEmail] = useState('');
    const [toggleButton, setToggleButton] = useState(false);
    const [showManage, setShowManage] = useState('');

    const AddEmail = async () => {
        if (inputData == '') {
            // Alert('Please input Email');
            console.log("Please input Email");
            document.getElementById('addEmail').classList.add('error');
            toast.error('Email address must not be blank');
            setEmailShow(true);
        }
        else if (inputData && toggleButton) {
            // if (index){
            const NewItemData = {
                // id: new Date().getTime().toString(),
                trucker_id: selectedRowData.id,
                email: inputData,
                email_key: editEmail,
            }
            // }
            try {
                const res = await withRFSToken.post(TRUCKERADDEMAIL, NewItemData)
                    .then(function (res) {
                        const innerData = res.data.response_data;
                        setItems(innerData);
                        reload();
                        // loadDetails(truckerParent.trucker_id);
                        // setExportGrid(innerData.export);
                    });

            } catch (error) {
                console.error('Error fetching data:', error);
            }
            // setItems(items.map((elem) => {
            //     if(elem.id === editEmail){
            //         return {...elem, name: inputData}
            //     }
            //     return elem;
            // }));
            setInputData('');
            setEditEmail(null);
            setToggleButton(false);
            setEmailShow(false);
        } else {
            const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            const validateEmail = (email) => {
                return emailRegex.test(email);
            };
            if (!validateEmail(inputData)) {
                toast.error('Invalid email address');
                setEmailShow(true);
            } else {
                const NewItemData = {
                    // id: new Date().getTime().toString(),
                    trucker_id: selectedRowData.id,
                    email: inputData
                }
                try {
                    const res = await withRFSToken.post(TRUCKERADDEMAIL, NewItemData)
                        .then(function (res) {
                            const innerData = res.data.response_data;
                            setItems(innerData);
                            // setExportGrid(innerData.export);
                        });

                } catch (error) {
                    console.error('Error fetching data:', error);
                }
                // setItems([...items, NewItemData]);
                setEmailShow(false);
            }

            // localStorage.setItem('TruckerEmail', JSON.stringify(NewItemData));
        }
        setInputData('');
        // setEmailShow(false);

    }
    const handleKeyPress = () => { document.getElementById('addEmail').classList.remove('error'); }
    const deleteEmail = async (index) => {
        const updatedItem = items.filter((curElem) => {
            return curElem.id !== index;
        });
        try {
            const res = await withRFSToken.post(TRUCKERDELEMAIL, { trucker_id: selectedRowData.id, email_key: index })
                .then(function (res) {
                    const innerData = res.data.response_data;
                    setItems(innerData);
                    // setExportGrid(innerData.export);
                });

        } catch (error) {
            console.error('Error fetching data:', error);
        }
        // setItems(updatedItem);
    }
    const EditEmail = (index) => {
        // const email_toedit = items.find((elem) => {
        //     return elem.id == index;
        // });
        setEmailShow(true);
        setToggleButton(true);
        setInputData(items[index]);
        setEditEmail(index);
    }
    // useEffect(() => {
    //     localStorage.setItem('TruckerEmail', JSON.stringify(items));
    // }, [items])

    // +++++++++++++++++++ div +++++++++++++++++++++++++

    var settings = {
        dots: false,
        infinite: false,
        slidesToShow: 2,
        slidesToScroll: 1,

    };

    // +++++++++++++++++++++++++++++++++++ Silk Slider


    const [imgShow, setImgShow] = useState(false);
    const [selectedFile, setSelectedFile] = useState('');

    const handleFileClick = (file) => {
        setSelectedFile(file);
        setImgShow(true);
    };

    const handleClose = () => {
        setImgShow(false);
        setSelectedFile('');
    };

    const [files, setFiles] = useState([]);
    const fileInputRef = useRef(null);

    const handleDrop = (e) => {
        e.preventDefault();
        const droppedFiles = Array.from(e.dataTransfer.files);
        setFiles((prevFiles) => [...prevFiles, ...droppedFiles]);
    };

    const handleDragOver = (e) => {
        e.preventDefault();
    };

    const handleDeleteFile = (index) => {
        setFiles((prevFiles) => {
            const newFiles = [...prevFiles];
            newFiles.splice(index, 1);
            return newFiles;
        });
    };

    const handleBrowseFiles = (e) => {
        e.preventDefault();
        fileInputRef.current.click();
    };

    const handleFileChange = (e) => {
        const selectedFiles = Array.from(e.target.files);
        setFiles((prevFiles) => [...prevFiles, ...selectedFiles]);
    };


    // +++++++++++++++++++++++++++++++++++++++++++++++++++++ file upload
    const [stations, setstations] = useState([]);
    let [selected, setSelected] = useState([]);
    let [selectedop, setSelectedop] = useState([]);
    if (selected.length > 1) {
        selected = selected.slice(1);
    }
    if (selectedop.length > 1) {
        selectedop = selectedop.slice(1);
    }
    const handleBPSelectChange = async (selected) => {
        const lastSelected = selected.slice(-1);
        setSelected(lastSelected);
        // setSelected(selected);
        if (selected && selectedop) {
            console.log('111', selected);
            try {
                const res = await withRFSToken.post(TRUCKERRATELIST, { boardpoint: selected, offpoint: selectedop })
                    .then(function (res) {
                        const innerData = res.data.response_data;
                        setRateChart(innerData);
                    });

            } catch (error) {
                console.error('Error fetching data:', error);
            }
        } else if (selected && !selectedop) {
            console.log('222', selected);
            try {
                const res = await withRFSToken.post(TRUCKERRATELIST, { boardpoint: selected })
                    .then(function (res) {
                        const innerData = res.data.response_data;
                        setRateChart(innerData);
                    });

            } catch (error) {
                console.error('Error fetching data:', error);
            }
        } else {

        }

    };
    const handleOPSelectChange = async (selected) => {
        setSelectedop(selected)
        if (selectedop && selected) {
            try {
                const res = await withRFSToken.post(TRUCKERRATELIST, { boardpoint: selected, offpoint: selectedop })
                    .then(function (res) {
                        const innerData = res.data.response_data;
                        setRateChart(innerData);
                    });

            } catch (error) {
                console.error('Error fetching data:', error);
            }
        } else if (selectedop && !selected) {
            try {
                const res = await withRFSToken.post(TRUCKERRATELIST, { offpoint: selected })
                    .then(function (res) {
                        const innerData = res.data.response_data;
                        setRateChart(innerData);
                    });

            } catch (error) {
                console.error('Error fetching data:', error);
            }
        } else {

        }
    };

    const handleEditClick = (pos) => {
        let transformData = {}
        if (pos === 'at') {
            transformData = {
                position: pos,
                trucker_id: selectedRowData.trucker_id,
                truckerName: selectedRowData.trucker_name,
                TruckerPhone: selectedRowData.trucker_phone,
                truckerEmail: selectedRowData.trucker_email,
            }
        } else if (pos === 'ts') {
            transformData = {
                id: '',
                position: pos,
                trucker_id: selectedRowData.trucker_id,
            }
        }

        onEdit(transformData);
    }

    const openRates = (pos) => {
        setShowManage(pos)
    }

    const initialFormData = {
        type_of_truck: 'B',
        bookingTruck_type: 'E',
        new_schedule_data: {
            trip_type: 'O',
        },
        adrRequired: '1',
        extra_truck_specification: [],
        coload: [],
        carriers: [],
        filesWithBase64: [],
        temperature_range_one_start: '0',
        temperature_range_one_end: '0',
        temperature_range_two_start: '0',
        temperature_range_two_end: '0',
        temperature_range_three_start: '0',
        temperature_range_three_end: '0',
        rateType: 'FM',
    };
    const [bookingTruckList, setBookingTruckList] = useState([]);
    const [selectedIndex, setSelectedIndex] = useState(null);
    const [inputGroups, setInputGroups] = useState([]);
    const ltlOptoins = [
        { label: '1', value: '1' },
        { label: '2', value: '2' },
        { label: '3', value: '3' },
    ];

    const handleViaChange = (selected, index) => {
        const updatedViaPoints = [...formData.viaStation];
        updatedViaPoints[index] = selected?.value || '';
        setFormData({ ...formData, viaStation: updatedViaPoints });
    };

    const handleAddVia = () => {
        setFormData({ ...formData, viaStation: [...formData.viaStation, ''] });
    };

    const handleRemoveVia = (index) => {
        const updatedViaPoints = formData.viaStation.filter((_, i) => i !== index);
        setFormData({ ...formData, viaStation: updatedViaPoints });
    };

    const tempChange = (key, e) => {
        // setFormData({ ...formData, [type]: e.target.value });
        const numericValue = parseFloat(e.target.value);
        setFormData((prev) => {
            if (!isNaN(numericValue)) {
                if (key.endsWith('_end')) {
                    const startKey = key.replace('_end', '_start');
                    return {
                        ...prev,
                        [key]: Math.max(prev[startKey], Math.min(numericValue, 18)), // Clamp between start value and 18
                    };
                } else {
                    return {
                        ...prev,
                        [key]: Math.max(0, Math.min(numericValue, 18)), // Clamp between 0 and 18
                    };
                }
            } else {
                return {
                    ...prev,
                    [key]: key.endsWith('_end') ? prev[key.replace('_end', '_start')] : 0, // Reset to start value or 0
                };
            }
        });

    }
    const handleIncrease = (key, maxValue) => {
        // let temp = formData[type];
        // temp++;
        // setFormData({ ...formData, [type]: temp });

        setFormData((prev) => {
            let currentValue = parseFloat(prev[key]) || 0;
            if (key.endsWith('_end')) {
                const startKey = key.replace('_end', '_start');
                currentValue = Math.max(prev[startKey], currentValue); // Ensure it respects the start value
            }
            return {
                ...prev,
                [key]: Math.min(currentValue + 1, maxValue), // Increment and ensure it doesn't exceed max value
            };
        });
    }
    const handleDecrease = (key, minValue) => {
        // let temp = formData[type];
        // temp--;
        // setFormData({ ...formData, [type]: temp });

        setFormData((prev) => {
            let currentValue = parseFloat(prev[key]) || 0;
            if (key.endsWith('_end')) {
                const startKey = key.replace('_end', '_start');
                minValue = prev[startKey]; // Set minValue to the corresponding start value
            }
            return {
                ...prev,
                [key]: Math.max(currentValue - 1, minValue), // Decrement and ensure it doesn't go below min value
            };
        });
    }
    const handleInputChange = (e) => {
        // setSelectedIndex(null)
        const { name, value } = e.target;


        // setFormData((prevState) => {
        //     const updatedFormData = { ...prevState };

        //     if (name === 'adrShipments' || name === 'adrClasses') {
        //         updatedFormData.adrInfo = {
        //             ...updatedFormData.adrInfo,
        //             [name]: value,
        //         };
        //     } else if (name === 'adrShipments' || name === 'adrClasses') {
        //         updatedFormData.adrInfo = {
        //             ...updatedFormData.adrInfo,
        //             [name]: value,
        //         };
        //     } else {
        //         updatedFormData[name] = value;

        //         // Handle adrRequired 
        //         if (name === 'adrRequired') {
        //             if (value === '0') {
        //                 delete updatedFormData.adrInfo;
        //                 delete updatedFormData.adr_shipment;
        //                 delete updatedFormData.adr_class;
        //             } else if (value === '1') {
        //                 updatedFormData.adrInfo = {
        //                     adrShipments: '',
        //                     adrClasses: '',
        //                 };
        //             }
        //         }

        //         // Handle LTL logic
        //         if (name === 'ltl_details') {
        //             if (value === 'P') {
        //                 delete updatedFormData.ltl_vol;
        //             } else if (value === 'M') {
        //                 delete updatedFormData.ltl_pos;
        //             }
        //         }
        //     }

        //     return updatedFormData;
        // });

        setFormData((prevState) => {
            const updatedFormData = { ...prevState };

            if (name === 'adrShipments' || name === 'adrClasses') {
                updatedFormData.adrInfo = {
                    ...updatedFormData.adrInfo,
                    [name]: value,
                };
            } else if (name === 'ltlBasis' || name === 'positions' || name === 'volume') {
                updatedFormData.ltlDetails = {
                    ...updatedFormData.ltlDetails,
                    [name]: value,
                };

                // Clean up based on selected basis
                if (name === 'ltlBasis') {
                    if (value === 'Positions') {
                        delete updatedFormData.ltlDetails.volume;
                    } else if (value === 'Shipments') {
                        delete updatedFormData.ltlDetails.positions;
                    }
                }
            } else {
                updatedFormData[name] = value;

                if (name === 'adrRequired') {
                    if (value === '0') {
                        delete updatedFormData.adrInfo;
                        delete updatedFormData.adr_shipment;
                        delete updatedFormData.adr_class;
                    } else if (value === '1') {
                        updatedFormData.adrInfo = {
                            adrShipments: '',
                            adrClasses: [],
                        };
                    }
                }

                if (name === 'truckLoad') {
                    if (value === 'FTL') {
                        delete updatedFormData.ltlDetails;
                    } else if (value === 'LTL') {
                        updatedFormData.ltlDetails = {
                            ltlBasis: '',
                            positions: '',
                            volume: '',
                        };
                    }
                }
            }

            return updatedFormData;
        });

    }
    const handleExtraTruckSpecChange = (e) => {
        const { value, checked } = e.target;
        setFormData(prevFormData => {
            let updatedSpecifications = [...(prevFormData.extra_truck_specification || [])];
            if (checked) {
                updatedSpecifications.push(value); // Add selected option
            } else {
                updatedSpecifications = updatedSpecifications.filter(spec => spec !== value); // Remove unselected option
            }
            return {
                ...prevFormData,
                extra_truck_specification: updatedSpecifications,
            };
        });
    }

    const [showModal, setShowModal] = useState(false);
    const [truckerData, setTruckerData] = useState({});

    const handleModalOpen = async () => {
        let payload = formData;
        const viastn = formData.viaStation.some(i => i)
        if (!viastn) {
            const { viaStation, ...rest } = formData;
            payload = rest;
        } else {
            const viastnData = formData.viaStation.filter(i => i)
            payload = { ...formData, viaStation: viastnData }
        }
        // console.log("🚀 ~ handleModalOpen ~ payload:", payload)
        try {
            const res = await withRFSToken.post('fix-rate-search', payload);
            if (res.data.response_code === 200) {
                const innerData = res.data.response_data;
                const handlerRow = innerData?.find(i => i.trucking_company == truckerParent.trucker_name);
                setTruckerData(handlerRow)
                setShowModal(true)
            } else {
                toast.error(res.data.response_msg)
            }
        } catch (error) {
            console.error('Error fetching data:', error);
        }

    }
    const handleModalClose = () => { setShowModal(false); };
    const symbol = truckerData?.currency ? currencies?.find(obj => obj.hasOwnProperty(truckerData.currency))?.[truckerData.currency] : '€';

    return (
        <>
            {/* {console.log('formData', formData)} */}
            {disLoading &&
                <div className='mvt loader-container' style={{ top: '0', height: '1084px' }}><span className='mvt loader' style={{ left: 'calc(50% - 17px)', top: '40vh' }}></span></div>
            }
            {showManage === '' &&
                <Row className='mt-3'>
                    <Col lg="5" className='pt-4  brd_rgt' >
                        <div className='d-flex justify-content-between'>
                            <div>
                                <h4>Trucker Details</h4>
                                <p>Add truckers and manage truckers.</p>
                            </div>
                            <Link to='#' onClick={() => openRates('ts')} className='add_adres'>Truck Schedule</Link>
                        </div>
                        <div className='truck_info'>
                            <div className='d-flex justify-content-between'>
                                <h6>Trucker Information</h6>
                                <Button variant="link" onClick={() => handleEditClick('at')}><FontAwesomeIcon icon={faPencil} /> Edit</Button>
                            </div>

                            <ul>
                                <li>Trucker Name : <span>{selectedRowData?.trucker_name}</span></li>
                                <li>Trucker Email : <span>{selectedRowData?.trucker_email}</span></li>
                                <li>Phone No. :<span>{selectedRowData?.trucker_phone}</span></li>
                            </ul>
                        </div>
                        <div className='d-flex justify-content-between py-2'>
                            <h6>Request Email Address</h6>
                            <div className='align-self-center'>
                                <button onClick={inputEmailShow} className='add_adres'>+ Add Email</button>
                            </div>
                        </div>
                        <div className='addresses'>
                            {emailShow &&
                                <>
                                    <div className='add_email'>
                                        <input name='' value={inputData} onKeyDown={handleKeyPress} onChange={(e) => setInputData(e.target.value)} id='addEmail' type='text' placeholder='Email type here' />
                                        {toggleButton ? <button onClick={AddEmail}>Edit</button> : <button onClick={AddEmail}><FontAwesomeIcon icon={faPlus} /> Add</button>}
                                    </div>
                                </>
                            }
                            <div className='showItem'>
                                {items && items.map((elem, index) => {
                                    return (
                                        <div className='eachItem' key={index}>
                                            <h3><FontAwesomeIcon icon={faEnvelope} /> {elem}</h3>
                                            {/* <button>Edit</button> */}
                                            <div className='request_email'>
                                                <button onClick={() => EditEmail(index)}> <FontAwesomeIcon icon={faPencil} /> </button>
                                                <button onClick={() => deleteEmail(index)}> <FontAwesomeIcon icon={faTrashCan} /> </button>
                                            </div>
                                        </div>
                                    )
                                }
                                )}
                            </div>
                            <ImageUpload
                                // ref={imageUploadRef}
                                attachable_type={"trucker"}
                                attachable_id={selectedRowData?.trucker_id}
                                attachments={selectedRowData?.attachments}
                                onDeleteSuccess={() => loadDetails(selectedRowData?.trucker_id)}
                            />
                            <div className='my-3'>

                                {/* <div className='d-flex justify-content-between align-items-center'>
                                <h3 className='mb-0'>Attachments</h3>
                                <div className='d-flex rightdrop'>
                                    <Dropdown>
                                        <Dropdown.Toggle variant="link" id="dropdown-basic">
                                            <FontAwesomeIcon icon={faEllipsis} />
                                        </Dropdown.Toggle>

                                        <Dropdown.Menu>
                                            <Dropdown.Item href="#/action-1">Open gallery view</Dropdown.Item>
                                            <Dropdown.Item href="#/action-2">Download all</Dropdown.Item>
                                        </Dropdown.Menu>
                                    </Dropdown>

                                    <div
                                        onDrop={handleDrop}
                                        onDragOver={handleDragOver}
                                    >
                                        <button className='raplas' onClick={handleBrowseFiles}><FontAwesomeIcon icon={faPlus} /></button>
                                        <input
                                            type="file"
                                            ref={fileInputRef}
                                            style={{ display: 'none' }}
                                            onChange={handleFileChange}
                                            multiple
                                        />


                                    </div>
                                </div>
                            </div>

                            <div className='raslider'>
                                <div className="slider-container">
                                    {
                                        files.length > 2 ?
                                            <Slider {...settings}>
                                                {files.map((file, index) => (
                                                    <div key={index} className='slideimg'>
                                                        {file.type.startsWith('image/') ? (
                                                            <>
                                                                <img
                                                                    src={URL.createObjectURL(file)}
                                                                    alt="Preview"
                                                                    style={{ maxWidth: '30px', maxHeight: '30px', marginRight: '10px' }}
                                                                    onClick={() => handleFileClick(URL.createObjectURL(file))}
                                                                />
                                                                <span className='rafilename'>{file.name}</span>
                                                            </>
                                                        ) : (
                                                            <span className='d-flex rafilename'><img src={Docmnt} className='fileimg' /> {file.name}</span>
                                                        )}
                                                        <button className='slide_dltbtn' type="button" onClick={() => handleDeleteFile(index)}> <FontAwesomeIcon icon={faXmark} color='#656565' /></button>
                                                    </div>
                                                ))}
                                            </Slider>
                                            :
                                            <>
                                                <div className='nonslide'>
                                                    {files.map((file, index) => (
                                                        <div key={index} className='slideimg'>
                                                            {file.type.startsWith('image/') ? (
                                                                <>
                                                                    <img
                                                                        src={URL.createObjectURL(file)}
                                                                        alt="Preview"
                                                                        style={{ maxWidth: '30px', maxHeight: '30px', marginRight: '10px' }}
                                                                        onClick={() => handleFileClick(URL.createObjectURL(file))}
                                                                    />
                                                                    <span className='rafilename'>{file.name}</span>
                                                                </>
                                                            ) : (
                                                                <span className='d-flex rafilename'><img src={Docmnt} className='fileimg' /> {file.name}</span>
                                                            )}
                                                            <button className='slide_dltbtn' type="button" onClick={() => handleDeleteFile(index)}> <FontAwesomeIcon icon={faXmark} color='#656565' /></button>
                                                        </div>
                                                    ))}
                                                </div>
                                            </>
                                    }


                                </div>

                                <Modal show={imgShow} onHide={handleClose} centered className='imgmodal'>
                                    <Modal.Header closeButton onClick={handleClose}></Modal.Header>
                                    <Modal.Body >
                                        {console.log(selectedFile)}
                                        <img src={selectedFile} className="img-fluid" alt="Selected" />
                                    </Modal.Body>
                                </Modal>

                            </div> */}

                            </div>

                        </div>
                    </Col>
                    <Col className='pt-4'>
                        <div className='d-flex justify-content-between'>
                            <div>
                                <h4>Fixed Rates</h4>
                                <p>Add truckers and manage truckers.</p>
                            </div>
                            <div className='align-self-center'>
                                {/* <button onClick={modalShow} className='add_adres'>+ Add Rates</button> */}
                                <button onClick={() => openRates('mr')} className='add_adres'> Manage Rates</button>
                            </div>

                        </div>
                        {console.log('formData', formData)}
                        <div className='charter_from rateloop'>
                            <h4>Rate Lookup</h4>
                            <Form.Group as={Row} className='mb-2'>
                                <Col sm="6">
                                    <Form.Label>Boardpoint</Form.Label>
                                    <div className='autosugg'>
                                        <Select
                                            options={boardPoint}
                                            onChange={(selected) => {
                                                setFormData({ ...formData, boardPoint: selected.label });
                                            }}
                                            placeholder="Boardpoint"
                                            className='rfs_autoslct'
                                            name="boardpoint"
                                        // value={boardPoint.find(option => option.id === localFormData.boardpoint)}
                                        />
                                    </div>
                                </Col>
                                <Col sm="6">
                                    <Form.Label>Offpoint</Form.Label>
                                    <div className='autosugg'>
                                        <Select
                                            options={boardPoint}
                                            onChange={(selected) => {
                                                setFormData({ ...formData, offPoint: selected.label });
                                            }}
                                            placeholder="Offpoint"
                                            className='rfs_autoslct'
                                            name="offPoint"
                                        // value={boardPoint.find(option => option.id === localFormData.boardpoint)}
                                        />
                                    </div>
                                </Col>
                            </Form.Group>
                            <Form.Group as={Row} className='mb-2'>
                                <Col sm="6">
                                    <Form.Label>Via Station</Form.Label>
                                    {formData.viaStation.map((cp, index) => (
                                        <div className='autosugg mb-2'>
                                            <Select
                                                options={boardPoint}
                                                onChange={(selected) => handleViaChange(selected, index)}
                                                placeholder="Via Station"
                                                className='rfs_autoslct'
                                                name="viaStation"
                                                value={boardPoint.find(option => option.value === cp) || null}
                                            // value={boardPoint.find(option => option.id === localFormData.boardpoint)}
                                            />
                                            {formData.viaStation.length > 1 && (
                                                <Link to="#" className="via_trash" onClick={() => handleRemoveVia(index)}><img src={Trash} /></Link>
                                            )}
                                        </div>
                                    ))}

                                </Col>
                                <Col sm="6">

                                </Col>
                                <Link className="add_via" to="#" onClick={handleAddVia}>+ Add Via</Link>
                            </Form.Group>
                            <Form.Group as={Row}>
                                <Col sm='6'>
                                    <Form.Label>ADR Required <span>*</span></Form.Label>
                                    <div className='sl_status'>
                                        <Form.Check
                                            inline
                                            label="Yes"
                                            name="adrRequired"
                                            type='radio'
                                            id='1'
                                            value="1"
                                            checked={formData.adrRequired == 1}
                                            onChange={handleInputChange}
                                        />
                                        <Form.Check
                                            inline
                                            label="No"
                                            name="adrRequired"
                                            type='radio'
                                            id='0'
                                            value="0"
                                            checked={formData.adrRequired == 0}
                                            onChange={handleInputChange}
                                        />
                                    </div>
                                </Col>
                                <Col sm='6'>

                                </Col>
                            </Form.Group>
                            {formData.adrRequired == 1 &&
                                <Form.Group as={Row}>
                                    <Col sm='6'>
                                        <Form.Label>ADR Shipment <span></span></Form.Label>
                                        <Form.Control type="text"
                                            onChange={handleInputChange}
                                            onInput={(e) => { e.target.value = e.target.value.replace(/\D/g, '') }}
                                            value={formData.adrInfo.adrShipments}
                                            name='adrShipments' placeholder="ADR Shipment"
                                        />
                                    </Col>
                                    <Col sm='6'>
                                        <Form.Label>ADR Classes <span></span></Form.Label>
                                        <Select
                                            options={[
                                                { label: 1, value: 1 },
                                                { label: 2, value: 2 },
                                                { label: 3, value: 3 },
                                                { label: 4, value: 4 },
                                                { label: 5, value: 5 },
                                                { label: 6, value: 6 },
                                                { label: 7, value: 7 },
                                            ]}
                                            onChange={(selected) => {
                                                const selectedValues = selected ? selected.map(option => option.value) : [];
                                                const updatedData = { ...formData, adrInfo: { ...formData.adrInfo, adrClasses: selectedValues } };
                                                setFormData(updatedData);
                                            }}
                                            placeholder="ADR Classes"
                                            className='rfs_autoslct'
                                            name="adrClasses"
                                            isMulti
                                        // isDisabled={inputGroups?.length > 0}
                                        // value={ltlOptoins.find(option => option.value === String(formData.service_type_value))}
                                        />
                                    </Col>
                                </Form.Group>
                            }
                            <Form.Group as={Row}>
                                <Col sm='6'>
                                    <Form.Label>Temperature Control <span>*</span></Form.Label>
                                    <div className='sl_status'>

                                        <Form.Check
                                            inline
                                            label="Yes"
                                            name="temperatureControl"
                                            type='radio'
                                            id='Y'
                                            value="1"
                                            checked={formData.temperatureControl === '1'}
                                            onChange={handleInputChange}
                                        />
                                        <Form.Check
                                            inline
                                            label="No"
                                            name="temperatureControl"
                                            type='radio'
                                            id='N'
                                            value="0"
                                            checked={formData.temperatureControl === '0'}
                                            onChange={handleInputChange}
                                        />
                                    </div>
                                </Col>
                                <Col sm='6'>
                                    <Form.Label>Rollerbed <span>*</span></Form.Label>
                                    <div className="mb-2 sl_status">
                                        <Form.Check
                                            inline
                                            label="Yes"
                                            name="rollerbed"
                                            type='radio'
                                            id='yes'
                                            value="1"
                                            checked={formData.rollerbed === '1'}
                                            onChange={handleInputChange}
                                        />
                                        <Form.Check
                                            inline
                                            label="No"
                                            name="rollerbed"
                                            type='radio'
                                            id='no'
                                            value="0"
                                            checked={formData.rollerbed === '0'}
                                            onChange={handleInputChange}
                                        />
                                    </div>
                                </Col>
                            </Form.Group>
                            <Form.Group as={Row}>
                                <Col sm='6'>
                                    <Form.Label>Number of Drivers <span>*</span></Form.Label>
                                    <div className='sl_status num_drive'>
                                        <Form.Check
                                            inline
                                            label="1"
                                            name="numberOfDrivers"
                                            type='radio'
                                            id='1'
                                            value="1"
                                            checked={formData.numberOfDrivers == 1}
                                            onChange={handleInputChange}
                                        />
                                        <Form.Check
                                            inline
                                            label="2"
                                            name="numberOfDrivers"
                                            type='radio'
                                            id='2'
                                            value="2"
                                            checked={formData.numberOfDrivers == 2}
                                            onChange={handleInputChange}
                                        />
                                    </div>
                                </Col>
                                <Col sm='6'>
                                    <Form.Label>Weight <span>*</span></Form.Label>
                                    <Form.Control type="text" onChange={handleInputChange} value={formData.weight} name='weight' placeholder="" />
                                </Col>
                            </Form.Group>
                            <Form.Group as={Row}>
                                <Col sm='6'>
                                    <Form.Label>Truck Load <span>*</span></Form.Label>
                                    <div className='d-flex sl_status'>

                                        <Form.Check
                                            inline
                                            label="FTL"
                                            name="truckLoad"
                                            type='radio'
                                            id='ftl'
                                            value="FTL"
                                            disabled={inputGroups?.length > 0}
                                            checked={formData?.truckLoad === 'FTL'}
                                            onChange={handleInputChange}
                                        />

                                        <Form.Check
                                            inline
                                            label="LTL"
                                            name="truckLoad"
                                            type='radio'
                                            id='ltl'
                                            value="LTL"
                                            // disabled={inputGroups?.length > 0}
                                            checked={formData?.truckLoad === 'LTL'}
                                            onChange={handleInputChange}
                                        />
                                    </div>
                                </Col>
                                <Col sm='6'>
                                    <div className='ltl_drop'>
                                        {formData?.truckLoad === 'LTL' &&
                                            <>
                                                <Form.Label>LTL Details <span>*</span></Form.Label>
                                                <Form.Check
                                                    inline
                                                    label="Position"
                                                    name="ltlBasis"
                                                    type='radio'
                                                    id='pos'
                                                    value="Positions"
                                                    // disabled={inputGroups?.length > 0}
                                                    checked={formData?.ltlDetails.ltlBasis === 'Positions'}
                                                    onChange={handleInputChange}
                                                />

                                                <Form.Check
                                                    inline
                                                    label="M3"
                                                    name="ltlBasis"
                                                    type='radio'
                                                    id='m3'
                                                    value="Shipments"
                                                    // disabled={inputGroups?.length > 0}
                                                    checked={formData?.ltlDetails.ltlBasis === 'Shipments'}
                                                    onChange={handleInputChange}
                                                />
                                            </>
                                        }
                                    </div>
                                </Col>
                            </Form.Group>
                            {formData?.truckLoad === 'LTL' && formData?.ltlDetails.ltlBasis === 'Positions' &&
                                <Form.Group as={Row}>
                                    <Col sm='6'>
                                        <Select
                                            options={[
                                                { label: 'Position 1', value: 1 },
                                                { label: 'Position 2', value: 2 },
                                                { label: 'Position 3', value: 3 },
                                                { label: 'Position 4', value: 4 }
                                            ]}
                                            onChange={(selected) => {
                                                const updatedData = { ...formData, ltlDetails: { ...formData.ltlDetails, positions: selected.value } };
                                                setFormData(updatedData);
                                            }}
                                            placeholder="Amount of Positions"
                                            className='rfs_autoslct'
                                            name="positions"
                                        // isDisabled={inputGroups?.length > 0}
                                        // value={ltlOptoins.find(option => option.value === String(formData.service_type_value))}
                                        />
                                    </Col>
                                </Form.Group>
                            }
                            {formData?.truckLoad === 'LTL' && formData?.ltlDetails.ltlBasis === 'Shipments' &&
                                <Form.Group as={Row}>
                                    <Col sm='6'>
                                        <Form.Control type="text" onChange={handleInputChange} value={formData.ltlDetails.volume} name='volume' placeholder="" />
                                    </Col>
                                </Form.Group>
                            }
                            <Button onClick={handleModalOpen} className='search_rate mt-2'>Search Rate</Button>
                        </div>
                    </Col >
                    <Modal show={showModal} onHide={handleModalClose} className='addfrom' centered>
                        <Modal.Header closeButton>
                            <ModalTitle>Rates Found {formData?.boardPoint} - {formData?.offPoint}</ModalTitle>
                        </Modal.Header>
                        <Modal.Body>
                            {/* <p>Upload the filled in template to add ULDs.</p> */}
                            <div className='search_found_box'>
                                <ul>
                                    <h4>Standard Cost</h4>
                                    <li>
                                        <span>Truck Load</span>
                                        <span>{symbol} {truckerData?.standard_cost?.truck_load_price}</span>
                                    </li>
                                    <li>
                                        <span>Handling Cost</span>
                                        <span>{symbol} {truckerData?.standard_cost?.handling_cost}</span>
                                    </li>
                                    <li>
                                        <span>T1 Issuing</span>
                                        <span>{symbol} {truckerData?.standard_cost?.t1_issuing}</span>
                                    </li>
                                    <li>
                                        <span>T1 Clearnce</span>
                                        <span>{symbol} - {truckerData?.standard_cost?.t1_clearance}</span>
                                    </li>
                                    <p><span>Total Standard Cost</span> <span>{symbol} {truckerData?.standard_cost?.total_standard_cost}</span></p>
                                </ul>

                                <ul>
                                    <h4>Additional Cost</h4>
                                    <li>
                                        <span>Temperature Control</span>
                                        <span>{symbol} {truckerData?.additional_cost?.temperature_control}</span>
                                    </li>
                                    <li>
                                        <span>ADR - Shipment</span>
                                        <span>{symbol} {truckerData?.additional_cost?.adr_shipment}</span>
                                    </li>
                                    <li>
                                        <span>ADR - Driver</span>
                                        <span>{symbol} {truckerData?.additional_cost?.adr_driver}</span>
                                    </li>
                                    <li>
                                        <span>Double Driver</span>
                                        <span>{symbol} {truckerData?.additional_cost?.double_driver}</span>
                                    </li>
                                    <li>
                                        <span>Roller Bed</span>
                                        <span>{symbol} {truckerData?.additional_cost?.rollerbed}</span>
                                    </li>
                                    <li>
                                        <span>UK Su</span>
                                        <span>{symbol} {truckerData?.additional_cost?.uk_surcharge}</span>
                                    </li>
                                    <p><span>Total Additional Cost</span> <span>{symbol}  {truckerData?.additional_cost?.total_additional_cost}</span></p>
                                </ul>

                                <p><span>Total Truck - </span> <span>{symbol}  {truckerData?.total_cost}</span></p>

                            </div>
                        </Modal.Body>
                        <Modal.Footer>
                        </Modal.Footer>
                    </Modal>
                </Row >
            }
            {showManage === 'mr' && (
                <>
                    <button className='backbtn' onClick={() => setShowManage('')}> <FontAwesomeIcon icon={faArrowLeft} /> Back</button>
                    <ManageRate rowData={selectedRowData} reload={'fetchDataGrid'} dload={'reload'} onEdit={handleEditClick} />
                </>
            )}
            {showManage === 'ts' && (
                <>
                    <button className='backbtn' onClick={() => setShowManage('')}> <FontAwesomeIcon icon={faArrowLeft} /> Back</button>
                    <TruckSchedule rowData={selectedRowData} reload={'fetchDataGrid'} dload={'reload'} onAdd={handleEditClick} trucker_id={selectedRowData?.trucker_id} />
                </>
            )}

        </>
    )
}

export default TruckerDetails;